module.exports = __webpack_public_path__ + "media/landing-page/itegration-image-8b6bc39c.svg";